const API_URL = process.env.REACT_APP_API_BASE_URL;

export async function getPermissions(userId, search = "") {
  const res = await fetch(`${API_URL}/permissions?search=${search}`, {
    credentials: "include",
    headers: {
      "X-User-Id": userId,
    },
  });
  return res.json();
}

export async function getPermission(userId, id) {
  const res = await fetch(`${API_URL}/permissions/${id}`, {
    credentials: "include",
    headers: {
      "X-User-Id": userId,
    },
  });
  return res.json();
}

export async function createPermission(userId, data) {
  const res = await fetch(`${API_URL}/permissions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-User-Id": userId,
    },
    credentials: "include",
    body: JSON.stringify(data),
  });
  return res.json();
}

export async function updatePermission(userId, id, data) {
  const res = await fetch(`${API_URL}/permissions/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "X-User-Id": userId,
    },
    credentials: "include",
    body: JSON.stringify(data),
  });
  return res.ok;
}

export async function deletePermission(userId, id) {
  const res = await fetch(`${API_URL}/permissions/${id}`, {
    method: "DELETE",
    credentials: "include",
    headers: {
      "X-User-Id": userId,
    },
  });
  return res.ok;
}

export async function getMyPermissions(userId) {
  const res = await fetch(`${API_URL}/permissions/me`, {
    credentials: "include",
    headers: {
      "X-User-Id": userId,
    },
  });
  return res.json();
}
